
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class FiveAndMore extends Vue {
  @Prop() gallery!: Array<any>;
}
